import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  deleteRestorePointsVm(vmId, vcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/' + vmId + '/backups';
    return this.http
      .delete(url)
      .map(
        (res:any) => this.value = res
      );
  }

  deleteRestorePointsDeletedVm(vmId, vcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/deletedVm/' + vmId + '/backups';
    return this.http
      .delete(url)
      .map(
        (res:any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/delete-restore/delete-restore.service.ts